declare global {
  interface Window {
    ALLOY_THIRD_PARTY_SCRIPTS: { [key: string]: boolean };
  }
}

window.ALLOY_THIRD_PARTY_SCRIPTS = {};

function addScript(script: Partial<HTMLScriptElement>, onload?: () => void) {
  const scriptElement = document.createElement('script');
  Object.assign(scriptElement, script);
  scriptElement.type = 'text/javascript';
  if (onload) scriptElement.onload = onload;
  const s = document.getElementsByTagName('script')[0];
  if (s) {
    (s.parentNode as HTMLElement).insertBefore(scriptElement, s);
  }
}

function addScripts(
  scripts: Array<Partial<HTMLScriptElement>>,
  onLastLoad?: () => void
) {
  const onload = scripts.slice(1).length
    ? addScripts.bind(null, scripts.slice(1), onLastLoad)
    : onLastLoad;
  addScript(scripts[0], onload);
}

export default function loadScripts(
  flag: string,
  scripts: Array<Partial<HTMLScriptElement>>,
  callback?: () => void
) {
  if (window.ALLOY_THIRD_PARTY_SCRIPTS[flag]) return;

  window.ALLOY_THIRD_PARTY_SCRIPTS[flag] = true;
  addScripts(scripts, callback);
}
